export enum InvestRateType {
    custom = 'custom',
    selected = 'selected'
}
